import axios from 'axios';
import { baseUrl, apiKey } from '../config';

class  KbvPluginService  {
  constructor() {
  }
  fetchLeaguesMatchesFull = async () => {
    try {
      const response = await axios.get(`${baseUrl}/leagues/hot`, {
        headers: {
          ['x-signature']: apiKey,
        }
      });

      return response?.data?.data || null;
    } catch (error) {
      console.error(error);
      return { error: 'Server error' };
    }
  };

  fetchBangKeoMatches = async (queryObject) => {

    try {
      const response = await axios.get(`${baseUrl}/leagues/league-in-bangkeo-v2`, {
        headers: {
          ['x-signature']: apiKey,
        },
        params: {
          search: queryObject.search,
          filter: queryObject.filter,
          fields: queryObject.fields,
          include: queryObject.include,
          searchInclude: queryObject.searchInclude,
          filterInclude: queryObject.filterInclude,
          fieldsInclude: queryObject.fieldsInclude,
          filterOdds: queryObject.filterOdds,
          status: queryObject.status,
          order: queryObject.order,
          page: queryObject.page,
          limit: queryObject.limit,
        },
      });

      const payload = {
        data: response.data,
      }
      return payload;
    } catch (error) {
      console.error(error);
      return { error: 'Server error' };
    }
  };
}


const instance = new KbvPluginService();
export { instance as KbvPluginService };